/* one% claims strip: pause the loop while it is off-screen (hover pause is pure CSS). */
(function () {
  if (customElements.get('op-marquee')) return;
  class OpMarquee extends HTMLElement {
    connectedCallback() {
      const root = this.closest('.op-marquee') || this;
      if (!('IntersectionObserver' in window)) return;
      this.io = new IntersectionObserver((entries) => {
        root.classList.toggle('is-offscreen', !entries[0].isIntersecting);
      });
      this.io.observe(root);
    }
    disconnectedCallback() {
      if (this.io) this.io.disconnect();
    }
  }
  customElements.define('op-marquee', OpMarquee);
})();
